import { useEffect, useState } from 'react';
import styles from './TaskExecution.module.scss';
import TaskCardList from './elements/TaskCardList';
import { useAppSelector } from '../../app/hooks';
import { selectTaskExecution } from '../../data/taskExecutionSlice';
import TaskOverview from './elements/TaskOverview';
import { TaskDefinition, TaskExecutionType } from '../../api/models/tasks';
import { selectTaskDefinitions } from '../../data/taskDefinitionSlice';

const TaskExecution = () => {
  const allTaskExecutions = useAppSelector(selectTaskExecution).taskExecutionList;
  const allTaskDefinitions = useAppSelector(selectTaskDefinitions).taskDefinitionList;

  const [selectedTask, setSelectedTask] = useState<TaskExecutionType | null>(null);
  const [selectedTaskDefinitionId, setSelectedTaskDefinitionId] = useState<string | null>(null);
  const [selectedTaskDefinition, setSelectedTaskDefinition] = useState<TaskDefinition | null>(null);
  const [allTaskExecutionsWithDefinitions, setAllTaskExecutionsWithDefinitions] = useState<TaskExecutionType[]>([]);

  useEffect(() => {
    const tasksWithDefinitionsdefs: TaskExecutionType[] = allTaskExecutions
      .map((taskExecution) => {
        const correspondingDefinition = allTaskDefinitions.find(
          (taskDefinition) => taskDefinition.taskDefinitionId === taskExecution.taskDefinitionId,
        );
        if (correspondingDefinition) {
          const newTaskExecution: TaskExecutionType = {
            ...taskExecution,
            name: correspondingDefinition?.displayName ?? 'Unknown name',
          };
          if (correspondingDefinition.parentAssetType) {
            newTaskExecution.parentAssetType = correspondingDefinition.parentAssetType;
          }
          return newTaskExecution;
        }
      })
      .filter((task) => task !== undefined) as TaskExecutionType[];
    if (tasksWithDefinitionsdefs.length > 0 && !selectedTask) {
      setSelectedTask(tasksWithDefinitionsdefs[0]);
      setSelectedTaskDefinitionId(tasksWithDefinitionsdefs[0].taskDefinitionId);
    }
    setAllTaskExecutionsWithDefinitions(tasksWithDefinitionsdefs);
  }, [allTaskExecutions, allTaskDefinitions]);

  useEffect(() => {
    if (selectedTaskDefinitionId) {
      const selectedTaskDefinition = allTaskDefinitions.find(
        (taskDefinition) => taskDefinition.taskDefinitionId === selectedTaskDefinitionId,
      );
      if (selectedTaskDefinition) {
        setSelectedTaskDefinition(selectedTaskDefinition);
      }
    }
  }, [selectedTaskDefinitionId]);

  useEffect(() => {
    if (selectedTask) {
      setSelectedTaskDefinitionId(selectedTask.taskDefinitionId);
    }
  }, [selectedTask]);

  return (
    <div className={styles.wrapper}>
      {allTaskExecutionsWithDefinitions.length > 0 && !!selectedTaskDefinition && !!selectedTask ? (
        <>
          <div className={styles.taskListWrapper}>
            <TaskCardList
              taskList={allTaskExecutionsWithDefinitions}
              selectedTask={selectedTask}
              setSelectedTask={setSelectedTask}
              taskDefinitions={allTaskDefinitions}
            />
          </div>
          {selectedTask && (
            <div className={styles.taskOverviewWrapper}>
              <TaskOverview selectedTask={selectedTask} taskDefinition={selectedTaskDefinition} />
            </div>
          )}
        </>
      ) : (
        <div className={styles.noTasksMessage}>No task executions are available yet.</div>
      )}
    </div>
  );
};

export default TaskExecution;
